const PRINT_FRAME_ID = 'prescription-a4-print-frame';

const A4_PRINT_CSS = `
  @page { size: A4; margin: 16mm 18mm; }
  * { box-sizing: border-box; }
  html, body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .rx-premium {
    font-family: Georgia, 'Times New Roman', 'DejaVu Serif', 'Palatino Linotype', serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.55;
    color: #000;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
  .rx-premium__content { flex: 1 1 auto; }
  .rx-premium__footer {
    flex-shrink: 0;
    margin-top: 1.6rem;
    padding-top: 0.35rem;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .rx-premium__band {
    height: 6px;
    margin: 0 0 0.85rem;
    background: #000;
  }
  .rx-premium__band--footer {
    margin: 1.1rem 0 0.65rem;
  }
  .rx-premium__header {
    text-align: center;
    padding: 0.1rem 0 0.55rem;
    margin-bottom: 0.55rem;
  }
  .rx-premium__top {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: start;
    gap: 0.45rem 0.65rem;
    margin-bottom: 0.45rem;
    text-align: left;
  }
  .rx-premium__logo {
    display: block;
    width: auto;
    max-width: min(100%, 144px);
    height: auto;
    max-height: 168px;
    margin: 0;
    object-fit: contain;
    grid-column: 1;
    grid-row: 1;
  }
  .rx-premium__brand-center {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
    text-align: center;
    min-width: 0;
    padding: 0 0.15rem;
  }
  .rx-premium__site-top {
    margin: 0;
    max-width: 7.5rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.02em;
    line-height: 1.3;
    text-align: right;
    color: #000;
  }
  .rx-premium__site-block {
    grid-column: 3;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.35rem;
    min-width: 0;
  }
  .rx-premium__barcode {
    display: block;
    width: min(100%, 260px);
    height: auto;
    margin: 0.4rem auto;
    padding: 0;
    border: 0;
  }
  .rx-premium__site-below { display: none; }
  .rx-premium__slogan {
    margin: 0 0 0.35rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8rem;
    font-weight: 500;
    font-style: italic;
    line-height: 1.35;
    color: #000;
  }
  .rx-premium__slogan span { display: block; }
  .rx-premium__header-rule {
    height: 0;
    margin: 0.55rem auto 0;
    border-top: 2px solid #000;
    border-bottom: 1px solid #000;
    padding-bottom: 3px;
  }
  .rx-premium__doc-title {
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.35rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #000;
  }
  .rx-premium__doc-number {
    margin: 0.15rem 0 0;
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.15rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    text-align: center;
    color: #000;
  }
  .rx-premium__reference {
    width: min(100%, 360px);
    margin: 0.35rem auto 0;
    padding: 0.3rem 0.65rem;
    border: 1px solid #000;
    border-radius: 2px;
    text-align: center;
  }
  .rx-premium__barcode-status {
    margin: 0.35rem 0 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.75rem;
    line-height: 1.3;
  }
  .rx-premium__site { display: none; }
  .rx-premium__fields {
    margin: 0 0 1rem;
    padding: 0.65rem 0.75rem;
    border: 1.5px solid #000;
    border-radius: 2px;
  }
  .rx-premium__field {
    display: flex;
    align-items: baseline;
    gap: 0.65rem;
    margin: 0 0 0.45rem;
  }
  .rx-premium__field:last-child { margin-bottom: 0; }
  .rx-premium__field-label {
    flex: 0 0 3.1rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 800;
  }
  .rx-premium__field-value {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 1.2rem;
    font-weight: 400;
  }
  .rx-premium__field-value--meta {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem;
    font-weight: 400;
  }
  .rx-premium__med-list {
    margin: 0 0 1.1rem;
    padding: 0.45rem 0 0;
    list-style: none;
    border-top: 1px solid #000;
  }
  .rx-premium__med-item {
    margin-bottom: 0.95rem;
    padding-bottom: 0.85rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .rx-premium__med-item:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  .rx-premium__med-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem 1rem;
  }
  .rx-premium__med-name {
    margin: 0;
    flex: 1;
    font-size: 1.4rem;
    font-weight: 400;
  }
  .rx-premium__med-qty {
    margin: 0;
    flex-shrink: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.9rem;
    font-weight: 400;
    white-space: nowrap;
    text-align: right;
  }
  .rx-premium__med-poso {
    margin: 0.4rem 0 0;
    padding-left: 0.85rem;
    border-left: 2px solid #000;
  }
  .rx-premium__med-poso-label {
    display: block;
    margin-bottom: 0.15rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.5625rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .rx-premium__med-line {
    margin: 0 0 0.12rem;
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 1.05rem;
    font-weight: 400;
    font-style: italic;
  }
  .rx-premium__empty {
    margin: 0 0 1rem;
    font-weight: 700;
  }
  .rx-premium__notes {
    margin: 0 0 1.2rem;
    padding: 0.7rem 0.8rem 0.75rem;
    border: 1.5px solid #000;
    border-radius: 4px;
  }
  .rx-premium__notes-label {
    display: block;
    margin-bottom: 0.3rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.5625rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .rx-premium__notes-body,
  .rx-premium__notes p {
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
  }
  .rx-premium__sign {
    margin-top: 0.45rem;
    margin-left: auto;
    width: min(100%, 15.5rem);
    text-align: center;
  }
  .rx-premium__stamp-label {
    margin: 0 0 0.35rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.04em;
  }
  .rx-premium__stamp {
    position: relative;
    min-height: 6.5rem;
    width: 100%;
    margin: 0 auto 0.55rem;
    border: 1.25px solid #000;
    border-radius: 2px;
  }
  .rx-premium__stamp::after {
    content: '';
    position: absolute;
    left: 0.75rem;
    right: 0.75rem;
    bottom: 0.85rem;
    border-bottom: 1.5px solid #000;
  }
  .rx-premium__doctor {
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 700;
  }
  .rx-premium__legal {
    margin-top: 0;
    padding-top: 0;
    text-align: center;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .rx-premium__legal p {
    margin: 0 0 0.3rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
  }
  .rx-premium__legal p:last-child { margin-bottom: 0; }
  .rx-premium__pricing {
    margin: 0 0 1.15rem;
    padding-top: 0.5rem;
    border-top: 1px solid #000;
  }
  .rx-premium__pricing-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    font-family: Arial, Helvetica, sans-serif;
  }
  .rx-premium__pricing-label { font-size: 0.8125rem; font-weight: 700; }
  .rx-premium__pricing-value { font-size: 0.9375rem; font-weight: 800; }
  .rx-premium__pricing-hint {
    margin: 0.35rem 0 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
  }
`;

function absoluteUrl(src) {
  const value = (src || '').trim();
  if (!value) return value;
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  const base = window.location.origin;
  const path = value.startsWith('/') ? value : `/${value}`;
  return `${base}${path}`;
}

function getPrintFrame() {
  let frame = document.getElementById(PRINT_FRAME_ID);
  if (frame) return frame;

  frame = document.createElement('iframe');
  frame.id = PRINT_FRAME_ID;
  frame.title = 'Impression ordonnance A4';
  frame.setAttribute('aria-hidden', 'true');
  frame.style.cssText =
    'position:fixed;width:0;height:0;border:0;opacity:0;pointer-events:none;left:-9999px;top:0';
  document.body.appendChild(frame);
  return frame;
}

function waitForImages(doc) {
  const images = Array.from(doc.images || []);
  if (!images.length) return Promise.resolve();

  return Promise.all(
    images.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }
          img.addEventListener('load', () => resolve(), { once: true });
          img.addEventListener('error', () => resolve(), { once: true });
        })
    )
  );
}

function buildPrintHtml(sheetHtml) {
  return `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8" />
  <title>Ordonnance</title>
  <style>${A4_PRINT_CSS}</style>
</head>
<body>${sheetHtml}</body>
</html>`;
}

export function printPrescriptionA4() {
  const sheet = document.getElementById('prescription-print-sheet');
  if (!sheet) return false;

  const clone = sheet.cloneNode(true);
  clone.querySelectorAll('img').forEach((img) => {
    img.setAttribute('src', absoluteUrl(img.getAttribute('src')));
  });

  const frame = getPrintFrame();
  const win = frame.contentWindow;
  if (!win) return false;

  const doc = win.document;
  doc.open();
  doc.write(buildPrintHtml(clone.outerHTML));
  doc.close();

  const triggerPrint = () => {
    try {
      win.focus();
      win.print();
    } catch {
      window.alert("Impossible de lancer l'impression de l'ordonnance.");
    }
  };

  win.addEventListener(
    'afterprint',
    () => {
      doc.open();
      doc.write('');
      doc.close();
    },
    { once: true }
  );

  void waitForImages(doc).then(() => {
    window.setTimeout(triggerPrint, 120);
  });

  return true;
}
